define.alias("shared/components/shared/ui/social-profile-switcher", "settings/components/shared/ui/social-profile-switcher");